import { List, Map } from 'immutable';

import { actionTypes as schedulerGanttPageActionTypes } from '../../../actions/SchedulerPage/schedulerGanttPageActions';
import { actionTypes as schedulerTasksPageActionTypes } from '../../../actions/SchedulerPage/schedulerTasksPageActions';
import { actionTypes as commonSchedulerActionTypes } from '../../../actions/SchedulerPage/commonSchedulerActions';
import { default as scheduleTaskDialogReducer } from './scheduleTaskDialogReducer';
import { default as createTaskDialogReducer } from './createTaskDialogReducer';
import { default as autoSchedulerDialogReducer } from './autoSchedulerDialogReducer';

let defaultState = {
  loading: false,
  schedulerData: null,
  data: {},
  counters: {},
  backtrackList: {
    undoItems: [],
    redoItems: [],
    lastMovedItemDate: null,
  },
  asyncScheduling: Map({
    status: null,
    summary: null,
    scheduledBy: null,
    statusPollingInterval: null,
    isAborting: false,
    activityLogId: null
  }),
  schedulerTasksGenerated: false,
};

export default function (state = Map(defaultState), action) {
  state = state.set('scheduleTaskDialog', scheduleTaskDialogReducer(state.get('scheduleTaskDialog'), action));
  state = state.set('createTaskDialog', createTaskDialogReducer(state.get('createTaskDialog'), action));
  state = state.set('autoSchedulerDialog', autoSchedulerDialogReducer(state.get('autoSchedulerDialog'), action));

  switch (action.type) {
    case schedulerGanttPageActionTypes.SCHEDULER_FETCH_SCHEDULER_DATA_FINISHED:
      
      // console.log('action.payload schedulerData ===> ', action.payload);
    
      state = state.set('schedulerData', action.payload);
      return state;

    case schedulerGanttPageActionTypes.SCHEDULER_GANTT_ZOOM_LEVEL:
      {
        let jsData = state.get('schedulerData');
        jsData.zoomLevel = action.payload;
        state = state.set('schedulerData', { ...jsData });
      }
      return state;

    case schedulerGanttPageActionTypes.SCHEDULER_GANTT_SCROLL_POSITION:
      {
        let jsData = state.get('schedulerData');
        jsData.scrollPosition = action.payload;
        state = state.set('schedulerData', { ...jsData });
      }
      return state;

    case commonSchedulerActionTypes.SCHEDULER_PAGE_RESET_DATA:
      return Map(defaultState);

    case commonSchedulerActionTypes.SCHEDULER_SET_LOADING:
      return state.set('loading', action.payload);

    case schedulerTasksPageActionTypes.SCHEDULER_FETCH_SCHEDULER_COUNTERS_FINISHED:
      return state.set('counters', action.payload);

    case schedulerTasksPageActionTypes.SCHEDULER_TASKS_GENERATED:
      return state.set('schedulerTasksGenerated', true);


    case schedulerGanttPageActionTypes.SCHEDULER_ADD_BACKTRACK_LIST_ITEM:
      {
        const backtrackList = state.get('backtrackList');
        const { payload } = action;
        backtrackList.undoItems.push({ ...payload, actionId: Math.random() });
        state = state.set('backtrackList', backtrackList);
      }
      return state;


    case schedulerGanttPageActionTypes.SCHEDULER_UPDATE_BACKTRACK_LIST_ITEM:
      {
        const backtrackList = state.get('backtrackList');
        const {
          payload: { type },
        } = action;
        if (type === 'undo' && !!backtrackList.undoItems.length) {
          backtrackList.redoItems.push(backtrackList.undoItems.pop());
        }
        if (type === 'redo' && !!backtrackList.redoItems.length) {
          backtrackList.undoItems.push(backtrackList.redoItems.pop());
        }
        state = state.set('backtrackList', backtrackList);
      }
      return state;
      
    case schedulerGanttPageActionTypes.SCHEDULER_CLEAR_BACKTRACK_LIST:
      return state.set('backtrackList', {
        undoItems: [],
        redoItems: [],
      });
      
    case schedulerGanttPageActionTypes.SCHEDULER_CLEAR_BACKTRACK_REDO_LIST:
      {
        const backtrackList = state.get('backtrackList');
        state = state.set('backtrackList', {
          undoItems: backtrackList.undoItems,
          redoItems: [],
        });
      }
      return state;
      
    case schedulerGanttPageActionTypes.SCHEDULER_STORE_MOVING_START_DATE:
      {
        const backtrackList = state.get('backtrackList');
        const { payload } = action;
        backtrackList.lastMovedItemDate = payload;
        state = state.set('backtrackList', backtrackList);
      }
      return state;
      
    case commonSchedulerActionTypes.SCHEDULER_ASYNC_STATUS:
      {
        const { payload: { status, summary, statusPollingInterval, activityLogId, scheduledBy } } = action;
        state = state.setIn(['asyncScheduling', 'status'], status);
        state = state.setIn(['asyncScheduling', 'summary'], summary);
        state = state.setIn(['asyncScheduling', 'activityLogId'], activityLogId);
        state = state.setIn(['asyncScheduling', 'scheduledBy'], scheduledBy);
        state = state.setIn(['asyncScheduling', 'statusPollingInterval'], statusPollingInterval);
      }
      return state;
      
    case commonSchedulerActionTypes.SCHEDULER_ASYNC_ABORTING:
      {
        const { payload } = action;
        state = state.setIn(['asyncScheduling', 'isAborting'], payload)
        return state;
      }


    case schedulerGanttPageActionTypes.SCHEDULER_MARK_EVENT_HAS_COMMENTS:
      
      let schedulerData = state.get('schedulerData');
      
      // Guard against action coming from a different page
      if (!schedulerData) {
        return state;
      }
      
      const HAS_COMMENTS_CLASS = 'event-has-comments';

      let eventTaskId = action.payload;
      
      let events = schedulerData.events || [];

      let foundEvent = events.find((event) => {
        return event.taskId === eventTaskId;
      });

      if (!foundEvent) {
        return state;
      }


      foundEvent.cls = addClassIfNotExists(foundEvent.cls, HAS_COMMENTS_CLASS);

      state = state.set('schedulerData', {
        ...schedulerData,
        events: [...events],
      });


      return state;



    default:
      return state;
  }
}





/////////////////////////////////////////////
// Helper functions
//

let addClassIfNotExists = function (strClasses, className) {

  /** @type {string[]} */
  let arrClasses = strClasses.split(' ').map(x => x.trim()) || [];

  let hasClass = arrClasses.includes(className);
  if (hasClass) {
    return strClasses; // No change needed, class already exists.
  }

  arrClasses.push(className);

  return arrClasses.join(' ');
}








